import tool1_1 from "../../assets/img/tools/tool-1-1.png";
import tool1_2 from "../../assets/img/tools/tool-1-2.png";
import tool1_3 from "../../assets/img/tools/tool-1-3.png";
import tool1_4 from "../../assets/img/tools/tool-1-4.png";
import tool1_5 from "../../assets/img/tools/tool-1-5.png";
import tool1_6 from "../../assets/img/tools/tool-1-6.png";
const ToolControl = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>Tool control solutions</h3>
          </div>

          <div className="fisherman-content bgGray">
            <h4 className="p-2">Introducing our range of products</h4>
          </div>
          <div className="toolControl">
            <div className="row">
              <div className="col-lg-7">
                <div className="fisherman-content">
                  <h4>Tools Managements System (ETMS) CTK Series</h4>
                </div>
                <div className="toolFlex">
                  <img src={tool1_3} alt="Overview" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="fisherman-content">
                  <h6>System Details</h6>
                  <ul>
                    <li>
                      <strong>Operating System: </strong>
                      <span>
                        Software Version: ETMS 1.0 Windows Compatible Micro PC
                        OS: Windows 11 17” touch display
                      </span>
                    </li>
                    <li>
                      <strong>Control Access: </strong>
                      <span>HF / UHF personal access card</span>
                    </li>

                    <li>
                      <strong>Power Input: </strong>
                      <span>110VAC - 240 VAC, 50/60 Hz, 6A</span>
                    </li>
                    <li>
                      <strong>Standard Cabinet Dimension (mm): </strong>
                      <span>L(590) × W(650) × H(1256)</span>
                    </li>
                    <li>
                      <strong>No. of Drawers: </strong>
                      <span>Standard 6 drawers</span>
                    </li>
                    <li>
                      <strong>
                        Standard Drawer Internal Dimensions (mm):{" "}
                      </strong>
                      <span>
                        M: L(370) × W(450) × H(90) L: L(370) × W(450) × H(137)
                      </span>
                    </li>
                    <li>
                      <strong>Battery (Optional): </strong>
                      <span>
                        444Wh, 404Wh/11.1V (equivalent to 120000mAh, 3.7V)
                      </span>
                    </li>
                    <li>
                      <strong>Printer (Optional): </strong>
                      <span>Paper Width: 79.5 ± 0.5 mm Interface: USB</span>
                    </li>

                    <li>
                      <strong>Notification Alerts (Optional): </strong>
                      <span>SMS notification service</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="toolControl">
            <div className="row">
              <div className="col-lg-8">
                <div className="fisherman-content">
                  <h4>Tools Managements System (ETMS) CTK Series</h4>
                  <h6>System Details</h6>
                  <ul>
                    <li>
                      <strong>Operating System: </strong>
                      <span>
                        Software Version: ETMS 1.0 Windows Compatible Micro PC
                        OS: Windows 11 17” touch display
                      </span>
                    </li>
                    <li>
                      <strong>Control Access: </strong>
                      <span>HF / UHF personal access card</span>
                    </li>
                    <li>
                      <strong>Lock System: </strong>
                      <span>
                        7 × 24V Electronic Locks (with manual override)
                      </span>
                    </li>
                    <li>
                      <strong>Power Input: </strong>
                      <span>110VAC - 240 VAC, 50/60 Hz, 6A</span>
                    </li>
                    <li>
                      <strong>Standard Cabinet Dimension (mm): </strong>
                      <span>L(1016) × W(650) × H(1500)</span>
                    </li>
                    <li>
                      <strong>No. of Drawers: </strong>
                      <span>
                        Standard 7 drawers Optional: Expandable with extension
                        cabinet, up to 16
                      </span>
                    </li>
                    <li>
                      <strong>
                        Standard Drawer Internal Dimensions (mm):{" "}
                      </strong>
                      <span>
                        L(1000) × W(450) × H(90) L(1000) × W(450) × H(200)
                      </span>
                    </li>
                    <li>
                      <strong>Extension Cabinet Dimensions (mm): </strong>
                      <span>L(576) × W(650) × H(1500)</span>
                    </li>
                    <li>
                      <strong>
                        Expandable Drawer Internal Dimensions (mm):{" "}
                      </strong>
                      <span>
                        M: L(440) × W(450) L: L(440) × W(450) × H(200)
                      </span>
                    </li>
                    <li>
                      <strong>Battery (Optional): </strong>
                      <span>
                        444Wh, 404Wh/11.1V (equivalent to 120000mAh, 3.7V)
                      </span>
                    </li>
                    <li>
                      <strong>Printer (Optional): </strong>
                      <span>Paper Width: 79.5 ± 0.5 mm Interface: USB</span>
                    </li>
                    <li>
                      <strong>Notification Alerts (Optional): </strong>
                      <span>SMS notification service</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="toolFlex">
                  <img src={tool1_1} alt="Overview" className="img-fluid" />
                  <img src={tool1_2} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>

          <div className="toolControl">
            <div className="row">
              <div className="col-lg-7">
                <div className="fisherman-content">
                  <h4>Tools Managements System (ETMS) CTK Series</h4>
                </div>
                <div className="toolFlex">
                  <img src={tool1_4} alt="Overview" className="img-fluid" />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="fisherman-content">
                  <h6>System Details</h6>
                  <ul>
                    <li>
                      <strong>Operating System: </strong>
                      <span>
                        Software Version: ETMS 1.0 Windows Compatible Micro PC
                        OS: Windows 11 17” touch display
                      </span>
                    </li>
                    <li>
                      <strong>Control Access: </strong>
                      <span>HF / UHF personal access card</span>
                    </li>
                    <li>
                      <strong>Lock System: </strong>
                      <span>
                        8 × 24V Electronic Locks (with manual override)
                      </span>
                    </li>

                    <li>
                      <strong>Power Input: </strong>
                      <span>110VAC - 240 VAC, 50/60 Hz, 6A</span>
                    </li>
                    <li>
                      <strong>Standard Cabinet Dimension (mm): </strong>
                      <span>L(1116) × W(650) × H(1500)</span>
                    </li>
                    <li>
                      <strong>No. of Drawers: </strong>
                      <span>Standard 7 drawers</span>
                    </li>
                    <li>
                      <strong>
                        Standard Drawer Internal Dimensions (mm):{" "}
                      </strong>
                      <span>
                        M: L(1000) × W(450) × H(90) L: L(1000) × W(450) × H(200)
                      </span>
                    </li>
                    <li>
                      <strong>Battery (Optional): </strong>
                      <span>
                        444Wh, 404Wh/11.1V (equivalent to 120000mAh, 3.7V)
                      </span>
                    </li>
                    <li>
                      <strong>Printer (Optional): </strong>
                      <span>Paper Width: 79.5 ± 0.5 mm Interface: USB</span>
                    </li>

                    <li>
                      <strong>Notification Alerts (Optional): </strong>
                      <span>SMS notification service</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="toolControl">
            <div className="row">
              <div className="col-lg-12">
                <div className="fisherman-content">
                  <h4>Tools Managements System (ETMS) CTK Series</h4>

                  <p>Designed and tailored for our smart storage systems</p>
                </div>

                <div className="toolFlex">
                  <img src={tool1_5} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
          <div className="toolControl">
            <div className="row">
              <div className="col-lg-12">
                <div className="fisherman-content">
                  <h4>Tools Managements System (ETMS) CTK Series</h4>

                  <p>Designed and tailored for our smart storage systems</p>
                </div>

                <div className="toolFlex">
                  <img src={tool1_6} alt="Overview" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>

          <div className="toolControl">
            <div className="row">
              <div className="col-lg-12">
                <div className="fisherman-content">
                  <h4>Our Business Strategy</h4>
                  <ul>
                    <li>
                      We offer services to trace different brands of tools
                      on-site, to develop tools stencils
                    </li>
                    <li>Partners advantage to continue using existing tools</li>
                    <li>Introducing alternative brands of tools if required</li>
                    <li>Comprehensive maintenance packages</li>
                    <li>
                      5 years warranty period for tools detection sensors PAT:
                      EP4120118
                    </li>
                    <li>
                      History of EVA foam shadow layout
                      <ol>
                        <li> Ease of adding tools</li>
                        <li> Ease of removing tools</li>
                        <li> Ease of changing entire layout</li>
                      </ol>
                    </li>
                  </ul>
                  <em>
                    Charges applies without comprehensive maintenance package
                    contract
                  </em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ToolControl;
